module.exports = window.wptravelengine.commonComponents;